// Kleiner Mengen-Wähler (−  n  +), Bereich 1..max. Genutzt bei Getränke-Bestellung.
export default function QtyStepper({ value, onChange, max = 99 }) {
  const set = (n) => onChange(Math.max(1, Math.min(max, n)));
  const btn = {
    width: 38, height: 38, borderRadius: "var(--radius-sm)",
    border: "1px solid var(--line)", background: "var(--bg-elevated)",
    color: "var(--ink)", fontSize: 18, cursor: "pointer", lineHeight: 1,
    fontFamily: "var(--font-body)", flexShrink: 0,
  };
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <button type="button" aria-label="weniger" onClick={() => set(value - 1)} disabled={value <= 1}
        style={{ ...btn, opacity: value <= 1 ? 0.4 : 1 }}>−</button>
      <span style={{ minWidth: 28, textAlign: "center", fontSize: 16, fontWeight: 600 }}>{value}</span>
      <button type="button" aria-label="mehr" onClick={() => set(value + 1)} disabled={value >= max}
        style={{ ...btn, opacity: value >= max ? 0.4 : 1 }}>+</button>
    </div>
  );
}
